var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 297,
    viewBox: "0 0 324 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356 16.6452C356 15.9351 356.377 15.2783 356.989 14.9194L381.989 0.277236C383.323 -0.503658 385 0.457882 385 2.00303V139.595C385 140.305 384.623 140.962 384.011 141.321L359.011 155.963C357.677 156.744 356 155.783 356 154.238V16.6452ZM0 219.438C0 218.725 0.379609 218.066 0.996357 217.708L27.9964 202.044C29.3297 201.27 31 202.232 31 203.774V341.377C31 342.09 30.6204 342.749 30.0036 343.107L3.00364 358.771C1.67031 359.545 0 358.583 0 357.041V219.438ZM56 187.576C56 186.856 56.3871 186.192 57.0135 185.837L328.014 32.1771C329.347 31.4211 331 32.3842 331 33.9169V171.071C331 171.791 330.613 172.455 329.986 172.811L58.9865 326.47C57.6532 327.226 56 326.263 56 324.73V187.576ZM171.659 65.8767C171.659 64.3453 170.009 63.3821 168.675 64.1354L1.0161 158.873C0.38824 159.227 0 159.893 0 160.614V185.896C0 187.428 1.65066 188.391 2.98391 187.638L170.643 92.9004C171.271 92.5457 171.659 91.8804 171.659 91.1592V65.8767ZM387 172.751C387 171.22 385.349 170.256 384.016 171.01L216.357 265.747C215.729 266.101 215.341 266.767 215.341 267.488V292.77C215.341 294.302 216.991 295.265 218.325 294.512L385.984 199.775C386.612 199.42 387 198.755 387 198.033V172.751Z",
    fill: "url(#paint0_linear_154_82)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_82",
    x1: 193.5,
    y1: 1,
    x2: 193.5,
    y2: 359.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8",
    stopOpacity: 0.49
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.c82fa145cf7a746b862c5e0c3be217e6.svg";
export { ForwardRef as ReactComponent };